<template>

<div class="row">
    <div class="col-12">
        
        <profile v-if='page == "profile"'></profile>
        <coin-payments v-if='page == "coinpayments"'></coin-payments>
        
    </div>
</div>

</template>

<script>
    export default {

        mounted() {

        },

        created() {

            if( typeof this.$route.params.page == 'undefined' ) {
                this.page = 'profile';
            } else {
                this.page = this.$route.params.page;
            }
        },

        data() {
            return {
                page : false,
                isReady : false,
            }
        },

        methods : {

        },

        components : {
            'profile'       : require("./Profile.vue").default,
            'pwd-change'    : require("./PasswordChange.vue").default,
            'coin-payments' : require("./CoinPayments.vue").default
        }

    }
</script>
